import { useEffect, useState } from "react";
import { styled } from "@mui/material";
import TopAndTabBarContainer from "@common/TopAndTabBarContainer";
import PageContainer from "@pageContent/common/PageContainer";
import { colors } from "@constants/cssVariables";
import SearchModalResult from "./components/SearchModalResult";
import SearchModalTabBar from "./components/SearchModalTabBar";
import SearchModalTopBar from "./components/SearchModalTopBar";
import useSearchValues from "./useSearchValues";

const SearchModalContainer = styled("div")(({ theme }) => ({
  zIndex: theme.zIndex.modal,
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  padding: theme.spacing(20, 0, 30),
  backgroundColor: colors.neutral0,
  overflow: "auto",
}));

const SearchModal: React.FC = () => {
  const { isModalOpen, searchParam, tabParam } = useSearchValues();
  const [hasResults, setHasResults] = useState(true);

  useEffect(() => {
    document.body.style.setProperty("position", isModalOpen ? "fixed" : "initial"); // Prevents background scrolling when the modal is open
  }, [isModalOpen]);

  useEffect(() => {
    const onSearchResults = (data: WebXEventParams["searchResults"]) => setHasResults(data.hasResults);
    window.eventBus.on("searchResults", onSearchResults);

    return () => window.eventBus.off("searchResults", onSearchResults);
  }, []);

  if (!isModalOpen) {
    return null;
  }

  return (
    <SearchModalContainer>
      <TopAndTabBarContainer>
        <SearchModalTopBar />
        {searchParam && (hasResults || tabParam) && <SearchModalTabBar />}
      </TopAndTabBarContainer>
      <PageContainer>
        <SearchModalResult />
      </PageContainer>
    </SearchModalContainer>
  );
};

export default SearchModal;
